import { render, staticRenderFns } from "./commonSuccess.vue?vue&type=template&id=0acbced4&scoped=true&lang=pug&"
import script from "./commonSuccess.vue?vue&type=script&lang=js&"
export * from "./commonSuccess.vue?vue&type=script&lang=js&"
import style0 from "./commonSuccess.vue?vue&type=style&index=0&id=0acbced4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbced4",
  null
  
)

export default component.exports